import { forTemplate } from 'app/common/lib/util/i18n';
import l from 'app/scripts/lib/localize.coffee';
import moment from 'moment';
import {
  PrimaryButton,
  DangerButton,
} from 'app/common/components/controls/button/button';
import React, { useState, useEffect, useCallback } from 'react';
import { Spinner } from 'app/src/components/Spinner';
import styles from './ChooseDate.less';

const format = forTemplate('choose_date');

interface ChooseDateProps {
  dateInitial: Date | undefined;
  onSelect: (date: Date | null) => void;
}

function getPikadayStrings() {
  return {
    previousMonth: l('prev month button text'),
    nextMonth: l('next month button text'),
    months: moment.months(),
    weekdays: moment.weekdays(),
    weekdaysShort: moment.weekdaysMin(),
  };
}

export function ChooseDate({ dateInitial, onSelect }: ChooseDateProps) {
  const [loading, setLoading] = useState(true);
  const [field, setField] = useState<HTMLInputElement | null>(null);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  const momentDateInitial = dateInitial && moment(dateInitial);
  const defaultDateString =
    momentDateInitial && momentDateInitial.isValid()
      ? momentDateInitial.format('l')
      : '';

  const [dateString, setDateString] = useState<string | undefined>(
    defaultDateString,
  );

  const momentDate = dateString ? moment(dateString.trim(), 'l') : undefined;

  useEffect(() => {
    if (field && container) {
      import(/* webpackChunkName: "pikaday" */ 'pikaday').then(
        ({ default: Pikaday }) => {
          new Pikaday({
            field,
            container,
            bound: false,
            format: 'l',
            firstDay: moment.localeData().firstDayOfWeek(),
            i18n: getPikadayStrings(),
            keyboardInput: false,
            onSelect: (date: Date) => setDateString(moment(date).format('l')),
            defaultDate: dateInitial,
            setDefaultDate: true,
          });
          setLoading(false);
        },
      );
    }
  }, [field, container, onSelect, dateInitial]);

  const onSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (momentDate) {
        onSelect(momentDate.toDate());
      }
    },
    [momentDate, onSelect],
  );

  return (
    <form onSubmit={onSubmit}>
      <input
        className="js-autofocus"
        autoFocus
        type="text"
        ref={setField}
        value={dateString}
        onChange={(e) => setDateString(e.target.value)}
      />
      <div ref={setContainer} />
      {loading && <Spinner />}
      <div className={styles.buttons}>
        <PrimaryButton
          type="submit"
          disabled={!momentDate || !momentDate.isValid()}
        >
          {format('save')}
        </PrimaryButton>
        <DangerButton onClick={(e) => onSelect(null)}>
          {format('remove')}
        </DangerButton>
      </div>
    </form>
  );
}
